import { State } from "..";

import { AbstractStore } from ".";

export interface TypeEntranceSound {
  server_id?: string;
  clip_id?: string;
}

/**
 * Stores the account-wide entrance sound selection.
 */
export class EntranceSound extends AbstractStore<
  "entrance_sound",
  TypeEntranceSound
> {
  constructor(state: State) {
    super(state, "entrance_sound");
  }

  hydrate(): void {
    /** nothing needs to be done */
  }

  default(): TypeEntranceSound {
    return {};
  }

  clean(input: Partial<TypeEntranceSound>): TypeEntranceSound {
    if (
      typeof input.server_id === "string" &&
      typeof input.clip_id === "string"
    ) {
      return {
        server_id: input.server_id,
        clip_id: input.clip_id,
      };
    }

    return {};
  }

  getSelection() {
    return this.get();
  }

  setSelection(serverId: string, clipId: string) {
    this.state.set("entrance_sound", {
      server_id: serverId,
      clip_id: clipId,
    });
  }

  clearSelection() {
    this.state.set("entrance_sound", {});
  }
}
